
import React, {  useEffect, useState, Suspense } from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';

import Content from '../widgets/core/content';

import styles from './assetviewer.module.scss';
import { useDesktop } from '../widgets/InteractiveContent';

const DocumentViewer = React.lazy(() =>
  import("@paperflite-marketing/asset-viewer").then((module) => ({
    default: module.DocumentViewer,
  }))
);

export const DocumentContentViewer = ({ asset, width, active, onLoad, loaded, onAnalyticsChange, onDebugAnalytics, scrollParent, inline, widgetId }) => {
  const contentContext = React.useContext(Content.Context);

  const id = _.get(asset, 'content.id');
  const type = _.get(asset, 'content.asset.viewer.type');
  const previewData = useSelector(state => _.get(state, `content.previews.${id}.item`));
  const loading = useSelector(state => _.get(state, `content.previews.${id}.loading`));

  const sourceUrl = _.get(asset, 'content.asset.viewer.url');

  const [preferredWidth, setPreferredWidth] = useState(width);
  const [offset, setOffset] = useState(205);
  const desktop = useDesktop();

  useEffect(() => {
    const offset = desktop ? 50 : 10;
    var widthValue = width - 2 * offset;
    widthValue = Math.min(widthValue, 1024);

    setPreferredWidth(widthValue);
  }, [width, desktop]);

  useEffect(() => {
    if (inline && loaded) {
      if (scrollParent === 'body') {
        var widgetElement = document.getElementById(widgetId);
        var widgetRect = widgetElement.getBoundingClientRect();
        setOffset(widgetRect.top * -1);
      } else {
        setOffset(0);
      }
    }
  }, [inline, loaded])

  return (
    <Suspense fallback={<div className={styles.documentViewer}></div>}>
      <DocumentViewer
        id={`${inline ? 'inline_' : ''}asset_viewer_${widgetId ? widgetId : id}`}
        inline={inline}
        sourceUrl={sourceUrl}
        previewData={previewData}
        fetchPreviewData={() => {
          if (type === 'enhanced_viewer') {
            contentContext.fetchPreviewDataForAsset(_.get(asset, 'content.id'));
          }
        }}
        loading={loading}
        loadingComponent={() => {
          return (
            <div className={cx(styles.loader)}>
              <div className={styles.videoWrapper}>
                <video loop autoPlay playsInline muted>
                  <source src="/images/Workspaceloader.webm" type="video/webm" />
                  <source src="/images/Workspaceloader.mp4" type="video/mp4" />
                </video>
                <label className={styles.message}>Generating Preview....</label>
              </div>
            </div>
          );
        }}
        scrollParent={scrollParent ? scrollParent : `.${styles.assetViewerContent}`}
        offset={offset}
        preferredWidth={preferredWidth}
        disabled={!active}
        workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js`}
        onPageChange={(page) => {

        }}
        onAnalyticsChange={onAnalyticsChange}
        onDebugAnalytics={onDebugAnalytics}
        onViewerRendered = {() => {
          if(onLoad){
            onLoad();
          }
        }}
      />
    </Suspense>
  );
}
